/** Admin UI groups raw order statuses into four buckets (matches summary cards). */
export const PENDING_STATUSES = [
  'pending',
  'pending_payment',
  'cod_pending',
  'paid',
  'confirmed',
] as const;

export const PREPARING_STATUSES = ['preparing', 'ready', 'delivering'] as const;

export type AdminOrderStatusVariant =
  | 'new'
  | 'preparing'
  | 'delivered'
  | 'cancelled';

export function adminOrderStatusLabel(status: string | undefined): string {
  const s = (status || '').toLowerCase();
  if (s === 'cancelled') return 'Cancelled';
  if (s === 'delivered') return 'Delivered';
  if (PREPARING_STATUSES.includes(s as (typeof PREPARING_STATUSES)[number])) {
    return 'Preparing';
  }
  if (PENDING_STATUSES.includes(s as (typeof PENDING_STATUSES)[number])) {
    return 'Pending';
  }
  return status || '–';
}

export function adminOrderStatusVariant(
  status: string | undefined
): AdminOrderStatusVariant {
  const s = (status || '').toLowerCase();
  if (s === 'cancelled') return 'cancelled';
  if (s === 'delivered') return 'delivered';
  if (PREPARING_STATUSES.includes(s as (typeof PREPARING_STATUSES)[number])) {
    return 'preparing';
  }
  return 'new';
}

/** Map admin filter dropdown value to raw DB statuses. */
export function adminStatusFilterValues(filter: string): string[] {
  const key = filter.toLowerCase();
  if (key === 'pending') return [...PENDING_STATUSES];
  if (key === 'preparing') return [...PREPARING_STATUSES];
  if (key === 'delivered') return ['delivered'];
  if (key === 'cancelled') return ['cancelled'];
  return [filter];
}
